import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const Pin = styled.img`
  height: 20px;
  width: 20px;
  transition: transform 100ms ease;
  transform-origin: center bottom;
  transform: translate(center bottom);
  &:hover {
    transform: scale(2);
  }
  ${({ hover }) =>
    hover &&
    css`
      transform: scale(2);
    `}
`;

export default class DefaultPin extends PureComponent {
  static propTypes = {
    $hover: PropTypes.bool,
    className: PropTypes.string,
  };

  render = () => (
    <Pin
      className={this.props.className}
      hover={this.props.$hover}
      src="/images/icons/map_pin.svg"
      alt="Map pin"
    />
  );
}
